import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.7097 41.1669C73.7097 41.1669 60.1497 34.2768 56.0997 29.5468C51.5997 24.2868 51.7997 1.64685 51.7997 1.64685H39.3797C39.3797 1.64685 39.6897 24.3968 35.0797 29.5468C30.1897 35.0068 17.4697 40.9669 17.4697 40.9669C23.6597 55.5469 36.0597 59.2669 45.5897 59.2669C55.1197 59.2669 67.5097 55.7468 73.7097 41.1669Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.24 58.0668C85.68 46.0568 82.03 42.8168 77.36 40.4668C75.06 39.3068 60.53 31.5868 60.53 31.5868L45.94 47.4368L30.64 31.5868C30.64 31.5868 16.2 39.2568 13.8 40.4668C9.12999 42.8168 5.56998 46.4468 3.91998 58.0668C2.43998 69.1268 2 71.8868 2 71.8868H89.15C89.16 71.8768 88.54 68.3568 87.24 58.0668Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M30.6396 31.5868L69.1296 71.6568" stroke={outline} strokeWidth="2" strokeMiterlimit="10" />
      <path d="M24.7803 35.1869L51.6003 71.6569" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M48.0797 71.6568L19.4297 37.7568" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M15.6396 39.9568L35.0897 71.6568" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M51.5996 53.5668L66.5696 34.8668" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M59.0303 61.3068L74.2103 39.6068" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M61.8701 63.6168L80.4601 42.8868" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5805"
          y1="42.8169"
          x2="45.5805"
          y2="8.78415"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
